module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "api-result"
  }, [(_vm.results && _vm.results.length) ? _c('div', {
    staticClass: "results"
  }, [_c('hr'), _vm._v(" "), _vm._t("default")], 2) : (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw"
  })]) : (_vm.response) ? _c('p', {
    staticClass: "no-results text-danger lead"
  }, [_vm._v("No results found")]) : _vm._e(), _vm._v(" "), _c('hr')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f0a64fa"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ApiResult.vue
// module id = 35
// module chunks = 0